export var RechargeHistoryStatus;
(function (RechargeHistoryStatus) {
    RechargeHistoryStatus["PAYMENT_PENDING"] = "PENDING";
    RechargeHistoryStatus["RELEASING_CREDIT"] = "PROCESSING";
    RechargeHistoryStatus["CREDIT_RELEASED"] = "APPROVED";
    RechargeHistoryStatus["CANCELLED"] = "CANCELED";
})(RechargeHistoryStatus || (RechargeHistoryStatus = {}));
export const PROTOCOL_MASK = '00000000000000';
export const PROTOCOL_LENGTH = 14;
export const RECHARGES_PER_PAGE = 20;
export const MAX_RECHARGES = 100;
export const RECHARGE_STATUS_LABELS = {
    [RechargeHistoryStatus.PAYMENT_PENDING]: 'benefits.recharge-history.status.payment-pending',
    [RechargeHistoryStatus.RELEASING_CREDIT]: 'benefits.recharge-history.status.releasing-credit',
    [RechargeHistoryStatus.CREDIT_RELEASED]: 'benefits.recharge-history.status.credit-released',
    [RechargeHistoryStatus.CANCELLED]: 'benefits.recharge-history.status.cancelled',
};
export const RECHARGE_HISTORY_ERRORS = {
    LOAD_ERROR: 'benefits.recharge-history.errors.load-error',
    SEARCH_NOT_FOUND: 'benefits.recharge-history.errors.search-not-found',
    SEARCH_ERROR: 'benefits.recharge-history.errors.search-error',
    EMPTY_STATE: 'benefits.recharge-history.errors.empty-state',
};
